import React from "react";
import { Row, Col } from "antd";
import { InputItem } from "../../../components/forms/FormItems";
import { FormattedMessage } from "react-intl";
import Surface from "../../../components/layouts/Surface";
import Spacer from "../../../components/layouts/Spacer";
import FormHeader from "../../../components/forms/FormHeader";
import ResponsiveItemsWrapper from "../../../components/layouts/ResponsiveItemsWrapper";

const Mail = () => {
  return (
    <Surface>
      <FormHeader title={<FormattedMessage id="app.organization.mail" />} />
      <Row>
        <Col xs={24} sm={24} md={24} lg={21} xl={15} xxl={10}>
          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              <InputItem name="smtp_server" category="organization" />
            </div>
            <Spacer horizontal={true} />
            <div style={{ flex: 1 }}>
              <InputItem
                number={true}
                name="smtp_port"
                category="organization"
              />
            </div>
          </ResponsiveItemsWrapper>

          <ResponsiveItemsWrapper>
            <div style={{ flex: 1 }}>
              <InputItem
                email={true}
                name="smtp_email"
                category="organization"
              />
            </div>
            <Spacer horizontal={true} />
            <div style={{ flex: 1 }}>
              <InputItem
                password={true}
                name="smtp_password"
                category="organization"
              />
            </div>
          </ResponsiveItemsWrapper>
        </Col>
      </Row>
    </Surface>
  );
};

export default Mail;
